<div
	class="flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
>
	{{ sectionTitle }}
</div>
<div class="grid grid-cols-2 gap-8 p-8 pt-4">
	@if (isClassroom) {
		<div class="form-display flex flex-col gap-2">
			<label class="form-label">{{ registrationLabel }}</label>
			<div class="form-value">
				{{ registrationValue }}
			</div>
		</div>
	} @else {
	<div class="form-display flex flex-col gap-2">
		<label class="form-label">{{ registrationLabel }}</label>
		<div class="form-value">
			{{ registrationValue }}
		</div>
	</div>
	<div class="form-display flex flex-col gap-2">
		<label class="form-label">{{ acTypeLabel }}</label>
		<div class="form-value">
			{{ acTypeValue() }}
		</div>
	</div>
	@if (showTs1V3FlightDetails) {
		<div class="form-display flex flex-col gap-2">
			<label class="form-label">Accumulated Sectors</label>
			<div class="form-value">
				{{ accumulatedSectorsValue() }}
			</div>
		</div>
		<div class="form-display flex flex-col gap-2">
			<label class="form-label">Sector No.</label>
			<div class="form-value">
				{{ sectorNumberValue() }}
			</div>
		</div>
		@if (showMultiSectorIcaoList()) {
			<div class="form-display col-span-2 flex flex-col gap-2">
				<label class="form-label">Departure &amp; Destination (ICAO)</label>
				<div class="form-value flex flex-col gap-1">
					@for (leg of sectorLegs(); track $index; let i = $index) {
						<span>{{ i + 1 }}. {{ leg.departureIcao || "-" }} → {{ leg.destinationIcao || "-" }}</span>
					}
				</div>
			</div>
		} @else {
			<div class="form-display flex flex-col gap-2">
				<label class="form-label">Departure (ICAO)</label>
				<div class="form-value">
					{{ departureIcaoValue() }}
				</div>
			</div>
			<div class="form-display flex flex-col gap-2">
				<label class="form-label">Destination (ICAO)</label>
				<div class="form-value">
					{{ destinationIcaoValue() }}
				</div>
			</div>
		}
		@if (showOtherAirportRoute()) {
			<div class="form-display flex flex-col gap-2">
				<label class="form-label">Other Airport(s)/Route(s)</label>
				<div class="form-value">
					{{ otherAirportsRouteValue() }}
				</div>
			</div>
		}
	} @else {
		<div class="form-display flex flex-col gap-2">
			<label class="form-label">Airport / Route</label>
			<div class="form-value">
				{{ airportRouteValue() }}
			</div>
		</div>
		<div class="form-display flex flex-col gap-2">
			<label class="form-label">Sector Number</label>
			<div class="form-value">
				{{ sectorNumberValue() }}
			</div>
		</div>
		<div class="form-display flex flex-col gap-2">
			<label class="form-label">Accumulated Sectors</label>
			<div class="form-value">
				{{ accumulatedSectorsValue() }}
			</div>
		</div>
	}
	}
</div>
